module.exports = __webpack_public_path__ + "img/syukyaku-sytem-pa002.4b381123.png";